import * as actions from "../actions";
import * as mplActions from "../mpl.financing/actions";

let initialState = {};

const payout = (state = initialState, action) => {
  switch (action.type) {
    // GET REPORTS
    case actions.FINANCING_PAYOUT_INFO_REQUEST:
      return Object.assign({}, state, {
        [action.dataSent.FinancingId]: Object.assign(
          {},
          state[action.dataSent.FinancingId],
          {
            fetching: true,
          },
        ),
      });
    case actions.FINANCING_PAYOUT_INFO_SUCCESS:
      return Object.assign({}, state, {
        [action.dataSent.FinancingId]: Object.assign(
          {},
          state[action.dataSent.FinancingId],
          {
            fetching: false,
            fetched: true,
            data: action.response,
          },
        ),
      });
    case actions.FINANCING_PAYOUT_INFO_ERROR:
      return Object.assign({}, state, {
        [action.dataSent.FinancingId]: Object.assign(
          {},
          state[action.dataSent.FinancingId],
          {
            fetching: false,
            error: action.error,
          },
        ),
      });
    // Same for MPL
    case mplActions.MPL_FINANCING_PAYOUT_INFO_REQUEST:
      return Object.assign({}, state, {
        [action.dataSent.FinancingId]: Object.assign(
          {},
          state[action.dataSent.FinancingId],
          {
            fetching: true,
          },
        ),
      });
    case mplActions.MPL_FINANCING_PAYOUT_INFO_SUCCESS:
      return Object.assign({}, state, {
        [action.dataSent.FinancingId]: Object.assign(
          {},
          state[action.dataSent.FinancingId],
          {
            fetching: false,
            fetched: true,
            data: action.response,
          },
        ),
      });
    case mplActions.MPL_FINANCING_PAYOUT_INFO_ERROR:
      return Object.assign({}, state, {
        [action.dataSent.FinancingId]: Object.assign(
          {},
          state[action.dataSent.FinancingId],
          {
            fetching: false,
            error: action.error,
          },
        ),
      });
    default:
      return state;
  }
};

export default payout;
